import type { TFunction } from "i18next";

import { formatDateTime } from "../../../lib/datetime/displayDateTime";

export const getAnomalyCols = (t: TFunction) => [
  {
    name: t("anomalies.cols.category"),
    selector: (row: { category?: string }) => row.category || "",
    sortable: true,
  },
  {
    name: t("anomalies.cols.subcategory"),
    selector: (row: { subCategory?: string }) => row.subCategory || "",
    sortable: true,
  },
  {
    name: t("anomalies.cols.createdDate"),
    selector: (row: { createdDate?: string }) =>
      row.createdDate ? formatDateTime(row.createdDate) : "",
    sortable: true,
  },
];

const AnomalyModel = {
  get cols() {
    return getAnomalyCols(((key: string) => key) as TFunction);
  },
  createDialogOpts: (t: TFunction) => ({
    submitButtonText: t("common.create"),
    cancelButtonText: t("common.cancel"),
    title: t("anomalies.createTitle"),
    content: t("anomalies.createContent"),
  }),
  editDialogOpts: (t: TFunction) => ({
    submitButtonText: t("common.update"),
    cancelButtonText: t("common.cancel"),
    title: t("anomalies.editTitle"),
    content: t("anomalies.editContent"),
  }),
  WARNING: { color: "warning", icon: "warning", title: "", content: "", info: "" },
  ERROR: { color: "error", icon: "error", title: "", content: "", info: "" },
  SUCCESS: { color: "success", icon: "success", title: "", content: "", info: "" },
  async message(type: any, title: any, content: any, info: any) {
    return new Promise((resolve) => {
      type.title = title;
      type.content = content;
      type.info = info;
      resolve(type);
    });
  },
};

export default AnomalyModel;
